import { InstructionProps } from "../types";
import styles from "../style.module.css";
import ButtonLink from "../../../components/button-link";
import { isTelegramWebApp } from "../../../utils/telegram";
import CopyText from "../../../components/copytext";
const InstructionMacOS = ({accessData}: InstructionProps) => {
  const handleOpenHappWithConfig = () => {
    const happUrl = `happ://add/${accessData}`;

    if (isTelegramWebApp()) {
      // В Telegram Mini App кастомные схемы часто блокируются через location.href,
      // поэтому пробуем сначала открыть в новом контексте.
      const openedWindow = window.open(happUrl, "_blank");
      if (openedWindow) {
        return;
      }
    }

    window.location.assign(happUrl);
  };

  return (
    <>
      <h1>Настройка на macOS</h1>
      <p>Займет 2 минуты</p>
      <hr className={styles.separator}/>

      <div className={styles.step}>
        <h2>Шаг 1</h2>
        <p>Установите приложение, кликнув кнопку ниже. В нем вы будете включать и выключать VPN.</p>
        <p>🇷🇺 Для пользователей с регионом Россия в AppStore:</p>
        <ButtonLink label={"Установить incy"} href="https://apps.apple.com/ru/app/incy/id6756943388?l=ru"></ButtonLink>
        <p>🌍 Для других регионов в App Store:</p>
        <ButtonLink label={"Установить Happ"} href="https://apps.apple.com/us/app/happ-proxy-utility/id6504287215"></ButtonLink>
      </div>

      <div className={styles.step}>
        <h2>Шаг 2</h2>
        <h2>Для приложения incy</h2>
        <p>Скопируйте ссылку, кликнув кнопку ниже. Вставьте ее в приложение incy, чтобы добавить подписку.</p>
        <CopyText text={accessData}></CopyText>
        <h2>Для приложения Happ</h2>
        <p>Нажмите кнопку ниже, чтобы добавить подписку. Приложение откроется и подписка добавится автоматически.</p>
        <ButtonLink label={"Добавить подписку"} href="happ://" onClick={handleOpenHappWithConfig}></ButtonLink>
      </div>

      <div className={styles.step}>
        <h2>Шаг 3</h2>
        <p>На главном экране приложения появилась подписка Openway. Выберите сервер или оставьте тот, который выбран по умолчанию.</p>
        <div style={{backgroundColor: "var(--transperent-white-70)", padding: "16px", borderRadius: "16px", marginTop: "16px",marginBottom: "16px", border: "1px solid var(--transperent-white-100)"}}>
          <h3 style={{ marginTop: "0", display: "flex", alignItems: "center", gap: "4px"}}><img style={{width: "20px", height: "20px"}} src="/images/instruction/android/icon-save.svg" alt="Security" /> Обход белых списков</h3>
          <p style={{margin: 0}}>Чтобы обходить белые списки, выберите сервер «Обход глушилок»</p>
        </div>
        <img className={styles.image} src="/images/instruction/macos/MacOS_1.webp" alt="Step 3"/>
      </div>
     
      <div className={styles.step}>
        <h2>Шаг 4</h2>
        <p>Нажмите на кнопку в центре, чтобы включить VPN.</p>
        <img className={styles.image} src="/images/instruction/macos/MacOS_2.webp" alt="Step 4"/>
      </div>

      <div className={styles.step}>
        <h2>Готово</h2>
        <p>Включайте и выключайте VPN, используя это приложение.</p>
        <img className={styles.image} src="/images/instruction/macos/MacOS_3.webp" alt="Step 7"/>
      </div>

    </>
  );
};

export default InstructionMacOS;